class IdleTimer {
  private timeout: number;
  private onTimeout?: Function;
  private eventHandler: any;
  private interval: any;
  private _status: "idle" | "active" | "terminate" = "idle";

  constructor({
    timeout,
    onTimeout,
  }: {
    timeout: number;
    onTimeout?: Function;
  }) {
    this.timeout = timeout;
    this.onTimeout = onTimeout;
    this.eventHandler = this.updateExpiredTime.bind(this);
  }

  get status() {
    return this._status;
  }

  start() {
    this._status = "idle";
    this.tracker();
    this.startInterval();
  }

  stop() {
    this._status = "terminate";
    this.cleanUp();
  }

  private startInterval() {
    this.updateExpiredTime();

    this.interval = setInterval(() => {
      const value = localStorage.getItem("_expiredTime") || "0";
      const expiredTime = parseInt(value, 10);

      if (expiredTime < Date.now()) {
        this._status = "idle";
        if (this.onTimeout) this.onTimeout();
      }
    }, 1000);
  }

  private updateExpiredTime() {
    const timestamp = Date.now() + this.timeout * 1000;
    localStorage.setItem("_expiredTime", timestamp.toString());
    this._status = "active";
  }

  private cleanUp() {
    clearInterval(this.interval);
    this.removetracker();
  }

  private tracker() {
    window.addEventListener("mousemove", this.eventHandler);
    window.addEventListener("scroll", this.eventHandler);
    window.addEventListener("keydown", this.eventHandler);
  }

  private removetracker() {
    window.removeEventListener("mousemove", this.eventHandler);
    window.removeEventListener("scroll", this.eventHandler);
    window.removeEventListener("keydown", this.eventHandler);
  }
}

export default IdleTimer;
